import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';

export const OutfitOverviewPage = lazy(
  () =>
    import('./OutfitOverviewPage.eager').then(mod => ({
      default: mod.OutfitOverviewPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
